import { render, staticRenderFns } from "./DirectActions.vue?vue&type=template&id=1724ccf8&scoped=true"
import script from "./DirectActions.vue?vue&type=script&lang=ts"
export * from "./DirectActions.vue?vue&type=script&lang=ts"
import style0 from "./DirectActions.vue?vue&type=style&index=0&id=1724ccf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1724ccf8",
  null
  
)

export default component.exports